<ng-content select="[slot='layout-header']"></ng-content>
<main class="main">
  <ng-content select="[slot='layout-main']" class="layout-main"></ng-content>
</main>
<ng-content select="[slot='layout-footer']"></ng-content>
